__turbopack_context__.v({
  "couponImage": "Message-module-scss-module__oVzC-q__couponImage",
  "cupponMessage": "Message-module-scss-module__oVzC-q__cupponMessage",
  "error": "Message-module-scss-module__oVzC-q__error",
  "itemAddedToBag": "Message-module-scss-module__oVzC-q__itemAddedToBag",
  "success": "Message-module-scss-module__oVzC-q__success",
  "textDanger": "Message-module-scss-module__oVzC-q__textDanger",
  "textMoss": "Message-module-scss-module__oVzC-q__textMoss",
  "textOvercast": "Message-module-scss-module__oVzC-q__textOvercast",
  "textSuccess": "Message-module-scss-module__oVzC-q__textSuccess",
  "warning": "Message-module-scss-module__oVzC-q__warning",
  "warningOvercast": "Message-module-scss-module__oVzC-q__warningOvercast",
  "warningPeach": "Message-module-scss-module__oVzC-q__warningPeach",
});
